module.exports = __webpack_public_path__ + "static/media/lesfooterlogo.9f44267d.svg";